// Servicio de notificaciones (toast) no bloqueantes de Sherpa.
//
// Monta un único host (`ToastHost`) en `document.body` la primera vez que se
// usa, de forma independiente del árbol de componentes que lanza el aviso. Así
// el toast SOBREVIVE a la navegación / desmontaje del formulario (a diferencia
// de la antigua capa `.messages`, que vivía dentro del form y moría con él).
//
// Uso:  import { sherpaNotify } from '@/utils/toast'
//       sherpaNotify({ type: 'success'|'error'|'warning'|'info', message, duration })
//       - duration en ms; 0 = permanece hasta que el usuario lo cierra.
import { reactive, createApp } from 'vue'
import ToastHost from '@/components/shared/ToastHost.vue'

const state = reactive({ toasts: [] })
let seq = 0
let mounted = false

function ensureHost () {
  if (mounted) return
  const el = document.createElement('div')
  el.className = 'sherpa-toast-root'
  document.body.appendChild(el)
  createApp(ToastHost, { state: state, onDismiss: dismiss }).mount(el)
  mounted = true
}

export function dismiss (id) {
  const i = state.toasts.findIndex(t => t.id === id)
  if (i !== -1) {
    state.toasts.splice(i, 1)
  }
}

export function sherpaNotify ({ type = 'info', message = '', duration } = {}) {
  if (!message) {
    return null
  }
  ensureHost()
  const id = ++seq
  const ttl = (duration === undefined || duration === null) ? 3000 : duration
  state.toasts.push({ id: id, type: type, message: message, duration: ttl })
  if (ttl > 0) {
    setTimeout(() => dismiss(id), ttl)
  }
  return id
}
